import { Fragment, memo } from 'react';
import { Drawer } from '@JohnLewisPartnership/jl-design-system/components/drawer/Drawer';
import { OpenInNewOutlined } from '@JohnLewisPartnership/jl-design-system/components/icons/OpenInNewOutlined';
import { Message } from '@JohnLewisPartnership/jl-design-system/components/message/Message';
import styles from './EnergyDrawer.module.scss';
import { useEnergyDrawerData } from './useEnergyDrawerData';

const EnergyDrawer = () => {
  const { closeEnergyDrawer, energyDrawerData, isOpen } = useEnergyDrawerData();

  const getHeader = () => {
    return `Energy Rating: ${energyDrawerData?.energyRating}`;
  };

  const getInformationSheet = () => {
    if (!energyDrawerData?.energyInformationSheet) {
      return;
    }
    return (
      <span className={styles.energyInformationSheetSection}>
        <a
          href={energyDrawerData.energyInformationSheet}
          className={styles.energyInformationSheetLink}
          data-testid="engInfosheetLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          Product Information Sheet
        </a>
        <OpenInNewOutlined title="Open in new tab" size="medium" />
      </span>
    );
  };

  const getModalContent = () => {
    if (energyDrawerData.imageSrc) {
      return (
        <img
          className={styles.energyImg}
          src={energyDrawerData.imageSrc}
          alt={energyDrawerData.altText}
        />
      );
    }
    if (energyDrawerData.altText) {
      return (
        <Message
          type="information"
          dataTest="energy-drawer-message"
          body={energyDrawerData.altText}
        />
      );
    }
  };

  return (
    <Fragment>
      <Drawer
        className={styles.energyDrawer}
        heading={getHeader()}
        isDrawerLeft={false}
        isNarrow={false}
        isOpen={isOpen}
        onClose={closeEnergyDrawer}
        position="right"
      >
        {energyDrawerData && getInformationSheet()}
        {energyDrawerData && getModalContent()}
      </Drawer>
    </Fragment>
  );
};

export default memo(EnergyDrawer);
